import {request} from '@/assets/js/api/_helpers'


const ENDPOINT_REQUESTS_PURCHASES_CONTROL = '/api/requests/controls/purchases'


export default {
    list: (config) => request( 'GET', ENDPOINT_REQUESTS_PURCHASES_CONTROL, config),
    retrieve: ({id, ...config}) => request( 'GET', `${ENDPOINT_REQUESTS_PURCHASES_CONTROL}/${id}`, config),
}